import { TeamAvatar, Typography, UserAvatar } from '@pocketlaw/tetris';
import { Container } from './styled';
export function RequiredApproverCard(props) {
    const { type, name, reasoning } = props;
    return (<Container>
      {type === 'user' ? <UserAvatar size="sm" title={name}/> : <TeamAvatar size="sm" title={name}/>}
      <Typography $fontSize="small" $appearance="200">
        {reasoning}
      </Typography>
    </Container>);
}
